import { LogsBase } from "~/areas/configuration/components/Diagnostics/Logs/LogsBase";
export class ScheduledTriggerLogsPage extends LogsBase {
    constructor(props: {}) {
        super("ProcessRecurringScheduledDeployments", "Scheduled Trigger Logs", props);
    }
}
